/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Option_AlignmentInputs */



/**
* | output |
* | --- |
* | "Alignment" |
*
* @param {Compare_Event_Groups_Option_AlignmentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_option_alignment = /** @type {((inputs?: Compare_Event_Groups_Option_AlignmentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Option_AlignmentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Alignement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausrichtung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Allineamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выравнивание")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alineación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("结盟")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アライメント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संरेखण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alinhamento")
	return /** @type {LocalizedString} */ ("Alignment")
});